import { useState, useEffect } from 'react';
import logo from '@/assets/logo.svg';

interface SplashScreenProps {
  onComplete: () => void;
  minDuration?: number;
}

const SplashScreen = ({ onComplete, minDuration = 1200 }: SplashScreenProps) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsFading(true);
      setTimeout(() => {
        setIsVisible(false);
        onComplete();
      }, 400);
    }, minDuration);

    return () => clearTimeout(timer);
  }, [minDuration, onComplete]);

  if (!isVisible) return null;

  return (
    <div
      className={`fixed inset-0 z-[9999] flex items-center justify-center transition-opacity duration-400 ${
        isFading ? 'opacity-0' : 'opacity-100'
      }`}
      style={{ background: '#B39678' }}
    >
      <div className="absolute inset-0" style={{
        background: 'radial-gradient(ellipse at center, rgba(255,255,255,0.12) 0%, transparent 70%)'
      }} />
      <img
        src={logo}
        alt="Centrolegno Arreda"
        className="relative h-14 sm:h-16 w-auto"
        style={{
          filter: 'brightness(0) invert(1)'
        }}
      />
    </div>
  );
};

export default SplashScreen;
